<template>
  <vs-row vs-justify="center" id="payment-types">
    <vs-card>
      <div slot="header" id="data-privacy">
        <h3>{{ $t('PaymentType.Title') }}</h3>
      </div>
      <div>
        <vs-col vs-w="3">
          <div v-for="(item, key) in allPaymentTypes" class="flex">
            <div class="my-2 d-flex justify-content-around" @click="saveChoice(item.id)">
              <label class="mr-3 font-weight-bold">{{ item.title }}</label>
              <input type="checkbox" class="ml-auto" v-model="selectedPaymentTypes" :value="item.id" />
            </div>
          </div>
          <div>
            <div class="btn-alignment mt-4">
              <vs-button color="primary" @click="updatePaymentTypes()" class="w-100 mb-4 px-5">{{ $t("PaymentType.Update")
              }}</vs-button>
            </div>
          </div>
        </vs-col>
      </div>
    </vs-card>
  </vs-row>
</template>

<script>
import { businessService } from "../../_services";
export default {
  name: "PaymentType",
  data: () => ({
    allPaymentTypes: [],
    paymentTypes: [],
    selectedPaymentTypes: []
  }),
  methods: {
    showLoading() {
      this.$vs.loading({
        container: '#payment-types',
        scale: 0.6
      });
    },
    hideLoading() {
      this.$vs.loading.close('#payment-types > .con-vs-loading')
    },
    saveChoice(id) {
      const index = this.selectedPaymentTypes.indexOf(id);
      if (index === -1) {
        this.selectedPaymentTypes.push(id);
      }
      else {
        this.selectedPaymentTypes.splice(index, 1);
      }
    },
    updatePaymentTypes() {
      this.showLoading();
      let payload = new FormData();
      payload.append("modes", this.selectedPaymentTypes.join(","));
      businessService.updatePaymentTypes(payload).then(() => {
        this.notify(
          this.$t("Toasts.Successful"),
          this.$t("Display.EditKioskPrompt.ToastSuccess"),
          "success"
        );
        this.initPage();
      }).catch(() => {
        this.notify(this.$t('Toasts.Error'), this.$t('Profile.updatePrivacySettings.businessUpdateFail'), 'danger');
      }).finally(() => this.hideLoading());
    },
    initPage() {
      this.showLoading();
      businessService.getAllPaymentTypes().then((res) => {
        this.allPaymentTypes = res.data
        businessService.getPaymentTypes().then((res) => {
          this.selectedPaymentTypes = res.data.map(el => el.id)
        }).finally(() => {
          this.hideLoading()
        });
      });
    }
  },
  mounted() {
    this.initPage();
  },
  components: {}
};
</script>
